var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'minimize')?_c('img',{staticClass:"c-sidebar-brand-minimized",attrs:{"src":"/assets/images/sidebar-brand-minimized.svg"}}):_c('img',{staticClass:"c-sidebar-brand-full",attrs:{"src":"/assets/images/sidebar-brand-full.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }